import { filterSelectInput } from "components/form/DefaultConsultView/components/FilterInputs";
import Entity, { fetchArray } from "entity"
import { ValidatorHelper } from "functions"

export default class Produto extends Entity {
    static get collectionUID() {
        return "Produto";
    }
    async initialize() {
        this.data.status = "ATIVO";
    }
    static async onQuery(collection) {
        return collection
        // .where("status", "==", "ATIVO")
        .orderBy("nome");
    }

    static async validFieldErrors(values) {
        // console.log('values', values)
        let v = new ValidatorHelper();

        v.addRequired("grupo", "GRUPO")
        v.addRequired("nome", "NOME DO PRODUTO")

        let errorsMessage = v.valid(values);
        // console.log("errorsMessage", errorsMessage)
        if (errorsMessage.length) {
            return errorsMessage
        }

        let result = await fetchArray(this.getAll())

        // console.log("values", values)
        let temIgual

        // verificando duplicidade em alteração de produto
        if (values.uid) {
            temIgual = result.filter(p => {
                if (p.nome.toUpperCase() === values.nome.toUpperCase()
                    && p.grupo.nome.toUpperCase() === values.grupo.nome.toUpperCase()
                    && p.uid !== values.uid
                ) {
                    return true
                } else {
                    return false
                }
            })
        }

        // verificando duplicidade em criação de produto
        else {
            temIgual = result.filter(p => {
                if (p.nome.toUpperCase() === values.nome.toUpperCase()
                    && p.grupo.nome.toUpperCase() === values.grupo.nome.toUpperCase()
                ) {
                    return true
                } else {
                    return false
                }
            })
        }

        if (temIgual.length) {
            return ["Produto já existe"]
        }

        return null
    }

    static get labelField() {
        return "nome";
    }

    static get searchColumns() {
        return [
            // { field: "status", headerName: "STATUS", flex: 0.5, filter: true },           
            { field: "nome", headerName: "PRODUTO/SERVIÇO", flex: 2, filter: true/*, wrap: 'wrap'*/ },
            { field: "grupo.nome", headerName: "GRUPO", flex: 2, filter: true/*, wrap: 'wrap'*/ },
            {
                field: "status", headerName: "Status", flex: 1, filter: filterSelectInput("status", "Status", ["ATIVO", "INATIVO"])
            },
        ];
    }
}